import { Component } from '@angular/core';
import { PageService, SortService, FilterService, ResizeService, FreezeService } from '@syncfusion/ej2-angular-grids';
import { JournalResponseDto } from '../../shared/models/journalResponseDto';
import { ViewUserJournalComponent } from '../../view-user-journal/view-user-journal.component';
import { RequestType } from '../../enums/request-type.enum';
import { ServerPagedHistoryGrid } from '../../shared/grid/server-paged-history-grid';
import type { GridFields } from '../../shared/utils/grid-request';

@Component({
    selector: 'xp-user-journal-history',
    templateUrl: './user-journal-history.component.html',
    styleUrl: './user-journal-history.component.scss',
    providers: [PageService, SortService, FilterService, ResizeService, FreezeService]
})
export class UserJournalHistoryComponent extends ServerPagedHistoryGrid<JournalResponseDto> {
    protected readonly requestType = RequestType.Journal;
    protected readonly path = 'journal';
    protected readonly completedRoute = 'journal-completed-requests';
    protected readonly filterKey = 'journal';
    protected readonly sheetName = 'Journal Requests';
    protected readonly exportFileName = 'User Journal Requests';
    protected readonly fields: GridFields = {
        id: 'number',
        dateRequested: 'date',
        matterFrom: 'text',
        clientName1: 'text',
        matterTo: 'text',
        clientName2: 'text',
        currencyCode: 'text',
        amount: 'number',
        clientBankAccountName1: 'text',
        clientBankAccountName2: 'text',
        reason: 'text',
        partnerAuthorisingName: 'text',
        dateAuthorised: 'date',
        dateTransaction: 'date',
        recentStatus: 'text',
        returnReason: 'text'
    };

    viewJournalRequest(request: JournalResponseDto): void {
        this.openDetails(ViewUserJournalComponent, request);
    }

    protected exportRow(item: JournalResponseDto): Record<string, unknown> {
        const row: Record<string, unknown> = {
            'Request Id': item.id || '',
            'Requested Date': this.exportDate(item.dateRequested),
            'Matter From': item.matterFrom || '',
            'CLient of Matter from': item.clientName1 || '',
            'Matter To': item.matterTo || '',
            'CLient of Matter to': item.clientName2 || '',
            'Currency': item.currencyCode ?? '',
            'Amount': item.amount ?? '',
            'Partner': item.partnerAuthorisingName || '',
            'Authorised Date': this.exportDate(item.dateAuthorised),
            'Transaction Date': this.exportDate(item.dateTransaction),
            'Status': item.recentStatus || ''
        };
        if (this.isCompletedTab) {
            row['Client Bank Account Name(From)'] = item.clientBankAccountName1 || '';
            row['Client Bank Account Name(To)'] = item.clientBankAccountName2 || '';
            row['Reason for Transfer'] = item.reason || '';
            row['Rejected Reason'] = item.returnReason || '';
        }
        return row;
    }
}
